import React, { useState } from 'react';
import { Alert } from 'reactstrap';
import Cookies from 'js-cookie';
import ResponsiveImageSet from '../ResponsiveImageSet/ResponsiveImageSet.jsx';
import NumbersAndBrandXs from '@core/assets/images/zahlen-und-marken-xs-rgb.svg';
import NumbersAndBrandLg from '@core/assets/images/zahlen-und-marken-lg-rgb.svg';

const NumbersAndBrand = (props) => {
    const cookieName = 'bigfoot_numbers-and-brand';
    const cookiesForNumbersAndBrand = Cookies.get(cookieName);

    const [isVisible, setIsVisible] = useState(!cookiesForNumbersAndBrand);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
        Cookies.set(cookieName, true, { expires: 180 });
    };

    if (process.env.REACT_APP_NUMBERS_AND_BRAND_COMPONENT === 'true' && isVisible) {
        return (
            <Alert color="dark" isOpen={isVisible} toggle={toggleVisibility} className={'p-0 overflow-hidden'}>
                <ResponsiveImageSet
                    imageXs={NumbersAndBrandXs}
                    imageLg={NumbersAndBrandLg}
                    altText="Zahlen und Marke"
                />
            </Alert>
        );
    } else {
        return <></>;
    }
};

export default NumbersAndBrand;
